import { render, staticRenderFns } from "./AuditInfo.vue?vue&type=template&id=87bfce10&"
import script from "./AuditInfo.vue?vue&type=script&lang=js&"
export * from "./AuditInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports